export default "__VITE_ASSET__GOC99I0p__"